import HelpSide from "../components/help/HelpSide"
import Phone from "../components/phone/Phone"
import VideoSide from "../components/video/VideoSide"


import Help from "../assets/icons/Help"
import Telephone from "../assets/icons/Telephone"
import Video from "../assets/icons/Video"


export const TabSupport =[
    {
        "id": 0,
        "icon":<Help/>,
        "text":"Frequently Asked Questions",
        "body": <HelpSide/>
    },
    {
        "id": 1,
        "icon":<Telephone/>,
        "text":"Manuals",
        "body": <Phone/>
    },
    {
        "id": 2,
        "icon":<Video/>,
        "text":"Videos",
        "body": <VideoSide/>
    },
]